import { render } from "./requests.vue?vue&type=template&id=18ebe59a&scoped=true"
import script from "./requests.vue?vue&type=script&lang=js"
export * from "./requests.vue?vue&type=script&lang=js"

import "./requests.vue?vue&type=style&index=0&id=18ebe59a&scoped=true&lang=css"
import "./requests.vue?vue&type=style&index=1&id=18ebe59a&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18ebe59a"]])

export default __exports__